<template>
  <div class="mfp-container">
    <h6 style="padding: 0;">{{$t('map.period')}}</h6>
    <div class="mt-3 mb-2">
      <b-button v-for="(v,k,i) in $c.PERIOD" variant="white" size="sm" :key="i"
                :pressed="checkPeriod(v)" @click="togglePeriod(v)">{{k}}</b-button>
    </div>
    <!-- regist_date -->
    <div v-if="checkPeriod($c.PERIOD[$t('map.all')]) || checkPeriod($c.PERIOD[$t('map.regist_date')])">
      <h6 class="mt-5" style="padding: 0;">{{$t('map.regist_date')}}
        <small class="price">
          {{rdate[0] == 0 ? month2str(24) + $t('map.before') : $moment().subtract(24-rdate[0], 'month').startOf('month').format('YY/MM/DD')}}
          ~
          {{rdate[1] == 24 ? $t('map.today') : $moment().subtract(24-rdate[1], 'month').startOf('month').format('YY/MM/DD')}}
        </small>
      </h6>
      <div class="mt-3 mb-5 mr-3 ml-3">
        <vue-slider v-model="rdate" :enable-cross="false" :min="0"
                  :max="24" :tooltip="'none'" :marks="marks">
          <template v-slot:mark="{pos, label}">
            <div class="custom-mark text-center" :style="{ left: `${pos}%` }">
              |<br>{{ label }}
            </div>
          </template>
        </vue-slider>
      </div>
    </div>
    <!-- open_date -->
    <div v-if="checkPeriod($c.PERIOD[$t('map.all')]) || checkPeriod($c.PERIOD[$t('map.open_date')])">
      <h6 class="mt-5">{{$t('map.opening_date')}}
        <small class="price" v-if="otype <= 0">
          {{$moment().subtract(50-odate[0], 'year').year() + $t('map.year1')}}{{odate[0] == 0 ? $t('map.before') : ''}}
          ~
          {{$moment().subtract(50-odate[1], 'year').year() + $t('map.year1')}}
        </small>
        <small class="price" v-else>
          <span v-for="(v,k,i) in $c.OPEN_DATE" :key="i" v-if="v == otype">{{k + $t('map.within')}}</span>
        </small>
      </h6>
      <div class="mt-3 mb-3 mr-3 ml-3">
        <b-button v-for="(v,k,i) in $c.OPEN_DATE" variant="white" size="sm" :key="i"
                  :pressed="otype == v" @click="otype = v">{{k}}</b-button>
      </div>
      <div class="mt-3 mb-5 mr-3 ml-3" v-if="otype <= 0">
        <vue-slider v-model="odate" :enable-cross="false" :min="0"
                  :max="50" :tooltip="'none'" :marks="marks_o">
          <template v-slot:mark="{pos, label}">
            <div class="custom-mark text-center" :style="{ left: `${pos}%` }">
              |<br><span v-html="label"></span>
            </div>
          </template>
        </vue-slider>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
const $u = require('util');

export default {
  name: 'MFPeriod',
  data: function() {
    return {
      marks: {
        '0':  {label: $u.format(this.$t('map.year'), 2) + this.$t('map.before')},
        '12': {label: $u.format(this.$t('map.year'), 1) + this.$t('map.within')},
        '24': {label: this.$t('map.today')},
      },
      marks_o: {
        '0': {label: moment().subtract(50, 'year').year() + this.$t('map.year_before')},
        '25': {label: moment().subtract(25, 'year').year() + this.$t('map.year_before')},
        '50': {label: moment().year() + this.$t('map.year_before')},
      }
    };
  },
  computed: {
    otype: {
      get: function() { return this.$store.getters.filter.open_date_type; },
      set: function(v) {
        if (v > 0)
          this.$store.commit('setFilter', {
            open_date_type: v,
            open_date_start: 0,
            open_date_end: 50,
          });
        else
          this.$store.commit('setFilter', {open_date_type: v});
      }
    },
    rdate: {
      get: function() {
        return [
          this.$store.getters.filter.reg_date_start,
          this.$store.getters.filter.reg_date_end,
        ];
      },
      set: function(v) {
        this.$store.commit('setFilter', {
          reg_date_start: v[0],
          reg_date_end: v[1],
        });
      },
    },
    odate: {
      get: function() {
        return [
          this.$store.getters.filter.open_date_start,
          this.$store.getters.filter.open_date_end,
        ];
      },
      set: function(v) {
        this.$store.commit('setFilter', {
          open_date_start: v[0],
          open_date_end: v[1],
        });
      },
    },
  },
  methods: {
    month2str: function(month) {
      if (month == 0)
        return this.$t('map.today');
      if (month < 12)
        return $u.format(this.$t('map.month'), month);
      let year = Math.floor(month / 12);
      month = month % 12;
      if (month == 0)
        return $u.format(this.$t('map.year'), year);
      else
        return $u.format(this.$t('map.year_month'), year, month);
    },
    checkPeriod: function(val) {
      if (val == '')
        return this.$store.getters.filter.period_type == '';
      var flts = (this.$store.getters.filter.period_type == '' ? [] :
                  this.$store.getters.filter.period_type.split(','));
      return (flts.indexOf(val) != -1);
    },
    togglePeriod: function(val) {
      if (val == '') {
        this.$store.commit('setFilter', {period_type: ''});
        return;
      }
      var flts = (this.$store.getters.filter.period_type == '' ? [] :
                  this.$store.getters.filter.period_type.split(','));
      var idx = flts.indexOf(val);
      if (idx != -1)
        flts.splice(idx, 1);
      else
        flts.push(val);
      this.$store.commit('setFilter', {period_type: flts.join(',')});
    },
  },
}
</script>

<style scoped lang="scss">
  @import '../../../assets/css/_vars.scss';
  h6 {
    font-size: $fs_22;
    font-family: $korean_gd_17_r;
    padding-top: 20px;
  }
  div.mfp-container {
    padding: 40px;
    background-color: white;
    width: 100%;
    margin: auto;
  }
  button {
    margin-right: 8px;
    font-size: $fs_20;
    font-family: $korean_gd_14_r;
    border-width: 0.5px;
    border-radius: 5px;
    border-color: #eeeeef;
    height: 50px;
    padding: .375rem .75rem;
  }
  h6>small.price {
    color: $primary;
    float: right;
    font-size: $fs_20;
    font-family: $korean_gd_14_r;
  }
</style>



// WEBPACK FOOTER //
// src/components/controls/mf/MFPeriod.vue